export const PUBLIC_WEBSITE_THEME_KEY = "public_website_theme";

export const normalizePublicWebsiteTheme = (theme) =>
  theme === "dark" ? "dark" : "light";

export const readStoredPublicWebsiteTheme = () => {
  if (typeof window === "undefined") return null;

  try {
    const theme = window.localStorage.getItem(PUBLIC_WEBSITE_THEME_KEY);
    return theme === "dark" || theme === "light" ? theme : null;
  } catch {
    return null;
  }
};

export const resolvePublicWebsiteTheme = () =>
  readStoredPublicWebsiteTheme() || "light";

export const applyPublicWebsiteTheme = (theme) => {
  const normalizedTheme = normalizePublicWebsiteTheme(theme);

  if (typeof window !== "undefined") {
    try {
      window.localStorage.setItem(
        PUBLIC_WEBSITE_THEME_KEY,
        normalizedTheme,
      );
    } catch {
      // The selected theme still applies until refresh if storage is unavailable.
    }
  }

  return normalizedTheme;
};
